
// import React from "react";
// import '../Assets/Css/webheader.css';
// import logo from '../Assets/Images/SiddhiIntl_Logo.png';
// import { NavLink } from 'react-router-dom';
// import Container from 'react-bootstrap/Container';
// import Nav from 'react-bootstrap/Nav';
// import Navbar from 'react-bootstrap/Navbar';
// import { FaLinkedin, FaFacebook, FaInstagram } from 'react-icons/fa';

// function WebHeader () {

//   return (
//     <>
//     <div className="fixed-top">
//       <div className="header-container ">
//         <div className="top-section">
//           <div className="logo-area">
//             <img src={logo} alt="Siddhi International" className="logo" />
//           </div>
//           <div className="social-area ">
//             <a href='https://www.linkedin.com/company/siddhinternational' className="social-link " target="_blank" rel="noopener noreferrer">
//               <FaLinkedin className="social-icon" />
//               <span className="social-name">LinkedIn</span>
//             </a>
//             <a  href='https://www.facebook.com/share/1Wtcc4PXR3/'className="social-link" target="_blank" rel="noopener noreferrer">
//               <FaFacebook className="social-icon" />
//               <span className="social-name">Facebook</span>
//             </a>
//             <a  href='https://www.instagram.com/siddhinternational?igsh=MTZpY2t1djV0N3JjNw==' className="social-link" target="_blank" rel="noopener noreferrer">
//               <FaInstagram className="social-icon" />
//               <span className="social-name">Instagram</span>
//             </a>
//           </div>
//         </div>
//       </div>

     
//       <Navbar className="custom-navbar">
//         <Container>
//           <Navbar.Collapse id="basic-navbar-nav">
//             <Nav className="mx-auto">
//               <Nav.Link as={NavLink} to="/" className="nav-link">Home</Nav.Link>
//               <Nav.Link as={NavLink} to="/aboutus" className="nav-link">About Us</Nav.Link>
//               <Nav.Link as={NavLink} to="/products" className="nav-link">Products</Nav.Link>
//               <Nav.Link as={NavLink} to="/contact" className="nav-link">Contact Us</Nav.Link>
//             </Nav>
//           </Navbar.Collapse>
//         </Container>
//       </Navbar>
//       </div>
//     </>
//   );
// }

// export default WebHeader;



import React, { useEffect, useState } from "react";
import '../Assets/Css/webheader.css';
import logo from '../Assets/Images/SiddhiIntl_Logo.png';
import { NavLink } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { FaLinkedin, FaFacebook, FaInstagram } from 'react-icons/fa';

function WebHeader() {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const headerHeight = document.querySelector('.header-container')?.offsetHeight || 180;
      setIsSticky(window.scrollY >= headerHeight);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  // useEffect(() => {
  //   const handleScroll = () => {
  //     const headerHeight = document.querySelector('.header-container')?.offsetHeight || 180;
  //     setIsSticky(window.scrollY >= headerHeight);
  //   };
  
  //   window.addEventListener('scroll', handleScroll);
  
  //   return () => window.removeEventListener('scroll', handleScroll);
  // }, []);
  
  // useEffect(() => {
  //   document.body.classList.toggle('navbar-sticky', isSticky);
  // }, [isSticky]);
  

  return (
    <>
      {/* Header stays at top initially */}
     
      <div className="header-container">
        <div className="top-section">
          <div className="logo-area">
            <img src={logo} alt="Siddhi International" className="logo" />
          </div>
          <div className="social-area">
            <a href='https://www.linkedin.com/company/siddhinternational' className="social-link" target="_blank" rel="noopener noreferrer">
              <FaLinkedin className="social-icon" />
              <span className="social-name">LinkedIn</span>
            </a>
            <a href='https://www.facebook.com/share/1Wtcc4PXR3/' className="social-link" target="_blank" rel="noopener noreferrer">
              <FaFacebook className="social-icon" />
              <span className="social-name">Facebook</span>
            </a>
            <a href='https://www.instagram.com/siddhinternational?igsh=MTZpY2t1djV0N3JjNw==' className="social-link" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="social-icon" />
              <span className="social-name">Instagram</span>
            </a>
          </div>
        </div>
      </div>

      {/* Always shown, becomes sticky on scroll */}
      <Navbar className={`custom-navbar ${isSticky ? 'sticky-navbar' : ''}`}>
        <Container>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mx-auto">
              <Nav.Link as={NavLink} to="/" className="nav-link">Home</Nav.Link>
              <Nav.Link as={NavLink} to="/aboutus" className="nav-link">About Us</Nav.Link>
              <Nav.Link as={NavLink} to="/products" className="nav-link">Products</Nav.Link>
              <Nav.Link as={NavLink} to="/contact" className="nav-link">Contact Us</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default WebHeader;
